/**
 * Spec 10.2.1 — money + time formatting for the ledger chrome (Q4 house style).
 * Stored as integer MINOR units; formatting is display-only: major units, 2dp,
 * grouped, tabular figures; negatives as "−" (danger colour reserved for genuine
 * negatives by the caller, via .money--neg / .projected--neg).
 */

/** Minor units → grouped major with 2dp, unicode minus for negatives. */
export function money(minor: number | null | undefined): string {
  if (minor == null) return "—";
  const v = (Math.abs(minor) / 100).toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return minor < 0 ? `−${v}` : v;
}

/** Short content-hash label, e.g. "sha256 · 2c81…44af". */
export function shortHash(hash: string): string {
  if (!hash || hash.length < 12) return `sha256 · ${hash}`;
  return `sha256 · ${hash.slice(0, 4)}…${hash.slice(-4)}`;
}

/** Milliseconds until an ISO expiry (negative = elapsed). */
export function msUntil(expiresAtIso: string): number {
  return new Date(expiresAtIso).getTime() - Date.now();
}

/** mm:ss for a positive ms duration; "expired" otherwise. */
export function mmss(ms: number): string {
  if (ms <= 0) return "expired";
  const total = Math.floor(ms / 1000);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
}

/** A concise "prepared by" phrase from the requesting actor. */
export function requestedByLabel(by: { kind: string; id: string; label: string | null }): string {
  if (by.label) return by.label;
  if (by.kind === "agent") return "an agent";
  if (by.kind === "system") return "the system";
  return "you";
}
